import { makeStyles } from "@material-ui/core/styles";

export const useGridStyles = makeStyles(() => ({
  grid: {
    margin: "36px 0 20px",
    "& h5": {
      "margin-left": "16px",
    },
  },
}));
